<template>
  <div class="operation-table">
    <div class="operation-table-head">
      <van-row>
        <van-col :span="6">{{ $t("option.num") }}</van-col>
        <van-col :span="7">{{ $t("option.price1") }}</van-col>
        <van-col :span="7">{{ $t("option.price2") }}</van-col>
        <van-col :span="4" class="txt-right">{{
          $t("option.profitandloss1")
        }}</van-col>
      </van-row>
    </div>
    <div class="data-box" v-if="list.length > 0">
      <div class="operation-table-body">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-if="list && list.length > 0"
            v-model="loading"
            :finished="finished"
            :finished-text="$t('common.nomore')"
            @load="onLoad"
          >
            <div
              v-for="(item, index) in list"
              :key="index"
              class="item"
              @click="toLook(item)"
            >
              <van-row>
                <van-col :span="4">{{ item.num }}</van-col>
                <van-col :span="8">{{ parseFloat(item.buyprice).toFixed(6) }}</van-col>
                <van-col :span="8">{{ parseFloat(item.sellprice).toFixed(6) }}</van-col>
                <van-col :span="4" class="txt-right">
                  <span v-if="item.status == 1"> -- </span>
                  <span
                    v-else
                    :class="item.is_win == 1 ? 'data-up' : 'data-down'"
                    >{{ item.ploss }}</span
                  >
                </van-col>
              </van-row>
              <van-divider />
              <van-row>
                <van-col :span="12">
                  {{ $t("option.order_time") }} : {{ item.selltime }}
                </van-col>
                <van-col :span="8">
                  <span v-if="item.status == 1">
                    {{
                      item.count_down > 0
                        ? $t("option.waitfinish")
                        : $t("option.finishing")
                    }}
                  </span>
                  <span v-if="item.status == 2">
                    {{ $t("option.finished") }}
                  </span>
                </van-col>
                <van-col :span="4" class="txt-right">
                  <span :class="item.hyzd == 1 ? 'data-up' : 'data-down'">{{
                    item.hyzd_text
                  }}</span>
                </van-col>
              </van-row>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <div v-else class="data-box">
      <van-empty :description="$t('common.nodata')" />
    </div>
    <van-popup v-model="show" round >
      <div class="settlement-item">
      <div class="title">
        <div>{{ lookitem.coinname }}</div>
        <div style="margin-left: 10px;">{{ lookitem.hyzd_text }}</div>
        <van-icon name="cross" class="close-btn" size="18" @click="show=false" />
      </div>
      <div class="content">
        <van-row>
          <van-col :span="12">{{
          $t("option.profitandloss1")
        }}</van-col>
          <van-col :span="12">{{ lookitem.ploss }}</van-col>
          <van-col :span="12">{{ $t("option.quantity") }}</van-col>
          <van-col :span="12">{{ lookitem.num }}</van-col>
          <van-col :span="12">{{ $t("option.price1") }}</van-col>
          <van-col :span="12">{{ lookitem.buyprice }}</van-col>
          <van-col :span="12">{{ $t("option.price2") }}</van-col>
          <van-col :span="12">{{ lookitem.sellprice }}</van-col>
          <van-col :span="12">{{ $t("option.times") }}</van-col>
          <van-col :span="12">{{ lookitem.buytime }}</van-col>
          <van-col :span="12">{{ $t("option.times1") }}</van-col>
          <van-col :span="12">{{ lookitem.selltime }}</van-col>
        </van-row>
      </div>
      <div class="btn">
        <van-button class="web-btn"  @click="show=false"
          >{{ $t('common.confirm') }}</van-button
        >
      </div>
    </div>
    </van-popup>
  </div>
</template>
  
  <script>
export default {
  name: "SettlementOrder",
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      limit: 10,
      show: false,
      lookitem:{}
    };
  },
  mounted() {
    //this.onRefresh();
  },
  methods: {
    onLoad() {
      this.getData();
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getHyOrderList",
        data: {
          status: 2,
          page: this.page,
          limit: this.limit,
        },
      }).then((res) => {
        this.refreshing = false;
        this.loading = false;
        if (res && res.data && res.data.list) {
          res.data.list.forEach((element) => {
            this.list.push(element);
          });
          if (res.data.list.length < this.limit) {
            this.finished = true;
          } else {
            this.page += 1;
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      this.page = 1;
      this.list = [];
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    toLook(item) {
      this.lookitem = item
      this.show = true
    },
  },
};
</script>
  
  <style>
</style>
  